/*
 * Get-donations.ts
 * Description: Includes the declaration
 * of the function for getting donations
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing Vuex
import {store} from '@/config/plugins';
// Importing JSON:API Normalization function
import normalize from 'normalize-json-api-response';

/**
 * Creating a list of donations
 *
 * @return {Object} Promise - a list of donations
 */
export function getDonations() {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'donations',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            // Assigning the data array to users
            store.dispatch('setResponse', normalize(response.data));
            store.dispatch('setLastPage', response.data.meta.last_page);
            resolve();
        }).catch(() => {
            reject();
        });
    });
}

/**
 * Get list of donated money
 *
 * @return {Object} Promise - a list of donations
 */
export function getDonatedMoney() {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'donated-funds',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            params: {
                page: store.getters.currentPage,
                order_by: store.getters.orderParam,
                sort_by: store.getters.sortParam,
            },
            data: {},
        }).then((response) => {
            // Assigning the data array to users
            store.dispatch('setResponse', normalize(response.data));
            store.dispatch('setLastPage', response.data.meta.last_page);
            resolve(normalize(response.data));
        }).catch(() => {
            reject();
        });
    });
}
